import { Grid, Stack, Typography } from '@mui/material';
import { SampleResultSchema } from '@/zod_schemas';
import { formatDateResults } from '@/utils/dateUtils';

interface DetailsInformationProps {
  result: SampleResultSchema;
}

const DetailsInformation = ({ result }: DetailsInformationProps) => (
  <Stack
    direction="column"
    spacing={2}
    sx={{
      height: '100%',
      p: 2,
      backgroundColor: 'background.default',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 2,
    }}
  >
    {/* Title Section */}
    <Grid item xs={12}>
      <Typography variant="subtitle1" fontWeight={700}>
        {result.pipeline?.name ?? 'Pipeline'}:{' '}
        {result.flowgate_pipeline_id ?? result.pipeline_config?.name ?? '—'}
      </Typography>
    </Grid>

    {/* Sample ID Section */}
    {result.samples.map((sample) => (
      <Grid key={sample.id} item xs={12}>
        <Typography variant="body2" color="primary" fontWeight={600}>
          Sample ID: {sample.sample_id}
        </Typography>
      </Grid>
    ))}

    {/* Date and Registered By Section */}
    <Grid item xs={12}>
      <Stack direction="column" spacing={1}>
        <Typography variant="body2">
          <strong>Created:</strong> {formatDateResults(result.created_at)}
        </Typography>
        <Typography variant="body2">
          <strong>Registered By:</strong> {result.created_by.first_name}
          {result.created_by.last_name}
        </Typography>
      </Stack>
    </Grid>
  </Stack>
);

export default DetailsInformation;
